module.exports = __webpack_public_path__ + "static/media/pswlogo.042ce25f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pswlogo.svg
// module id = ./src/images/pswlogo.svg
// module chunks = 2